import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const onePassword = defineConnector({
  identifier: "onePassword",
  name: "1Password",
  tagLine: "Password and secrets management",
  keywords:
    "onepassword op service account vaults items secrets credentials password manager",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.1password\\.(com|eu|ca)/.*",
  auth: (app) => bearerAuth(app.secret.serviceAccountToken),
  steps: [
    {
      title: "Create a 1Password service account",
      items: [
        {
          kind: "markdown",
          content:
            "In 1Password, open **Developer Tools → Directory → Service Account**, name your service account, and grant it access to the vaults you want to use. Copy the service account token. See the [1Password service accounts docs](https://developer.1password.com/docs/service-accounts/) for details.",
        },
      ],
    },
    {
      title: "Enter your service account token",
      items: [
        {
          kind: "input",
          label: "Service account token",
          required: true,
          target: { kind: "secrets", field: "serviceAccountToken" },
          helperText: "Starts with “ops_”.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://my.1password.com/api/v1/heartbeat",
  },
});
